import { Title as MantineTitle, TitleProps } from '@mantine/core'

export const Title = (props: TitleProps) => <MantineTitle {...props} />
